
let InterpretStatus = {
    pullModes : function (code) {
        switch (code){
            case 0:
                return 'FTP';
            case 1:
                return 'SFTP';
            case 2:
                return 'Medview';
            case 3:
                return 'Email';
            case 4:
                return 'Web Service';
            case 5:
                return 'Data Entry';
            case 6:
                return 'Overland Service';
            case 7:
                return 'Air France Klm FTP';
            case 8:
                return 'Azman Web Service';
            case 9:
                return 'Air Peace Web Service';
            case 10:
                return 'Arik Web Service';
            case 11:
                return 'Emirates FTP';
            default:
                return 'Anonymous';
        }
    }
};

export default InterpretStatus;



// WEBPACK FOOTER //
// ./src/views/utils/interpretor.js